import { Party, User } from '../types';

export function isThirdPartyParty(party: Partial<Party>, projectUsers?: User[]): boolean {
  if (party.type === 'External') return true;
  if (party.type === 'Internal') return false;

  if (!party.name) return false;

  if (projectUsers) {
    const nameMatch = projectUsers.some((u) => u.name === party.name);
    const emailMatch = party.contact ? projectUsers.some((u) => u.email === party.contact) : false;
    return !(nameMatch || emailMatch);
  }

  return false;
}

export function formatPartyLabel(party: Partial<Party>, projectUsers?: User[]): string {
  const name = party.name ?? 'Unknown';
  return isThirdPartyParty(party, projectUsers) ? `${name} (tp)` : name;
}

export function formatPartyLabelById(
  partyId: number,
  parties: Party[],
  projectUsers?: User[],
): string {
  const party = parties.find((p) => p.id === partyId);
  return party ? formatPartyLabel(party, projectUsers) : 'Unknown';
}
